import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const capstoneScreenModule = defineScreen({
  app: "coaching",
  screen_id: "capstone",
  path: "/capstone",
  heading: { text: "Capstone", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/capstone.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default capstoneScreenModule;
